//
//  BasicScreeningResults Reducer
//  CXA Apollo
//
//  Created on 07/12/2016.
//  Copyright (c) 2016 CXA. All rights reserved.
//

// Add ALL your actions into import list
import {
  basicScreeningResultsLoadBegin,
  basicScreeningResultsLoadSuccess,
  basicScreeningResultsLoadFailed,
  basicScreeningResultsPrintLoadBegin,
  basicScreeningResultsPrintLoadSuccess,
  basicScreeningResultsPrintLoadFailed,
} from "../actions/basicScreeningResultsActions";

import {
  transformScreeningResultsPayload,
  transformValueRanges,
  mapStatus,
} from "./advancedScreeningResultsReducer";

const initialState = {
  response: {},
  printResponse: {},
  fetching: false,
  fetched: false,
  error: null,
};

const groupMarkers = results => {
  const heightResult = results.find(result => result.tag === "height");
  const weightResult = results.find(result => result.tag === "weight");

  const markerGroupsMap = [
    {
      name: "Body Composition",
      tags: [
        { tag: "bmi", name: "BMI" },
        { tag: "waist", name: "Waist Circumference" },
      ],
    },
    {
      name: "Blood Pressure",
      tags: [
        { tag: "systolic_bp", name: "Systolic Blood Pressure" },
        { tag: "diastolic_bp", name: "Diastolic Blood Pressure" },
      ],
    },
    {
      name: "Lipids",
      tags: [{ tag: "total_cholesterol", name: "Total Cholesterol" }],
    },
    {
      name: "Glucose",
      tags: [{ tag: "fasting_glucose", name: "Blood Sugar" }],
    },
    {
      name: "Heart Rate",
      tags: [{ tag: "pulse_rate", name: "Heart Rate" }],
    },
  ];

  const markerGroups = markerGroupsMap
    .map(group => {
      const { tags, ...rest } = group;
      const biomarkers = tags
        .map(tag => {
          const res = results.find(item => item.tag === tag.tag);
          if (!res) {
            return null;
          }

          const {
            valueRanges,
            userValue,
            userUnit,
            questionValue,
            questionUnit,
            userHealthRiskDetail,
            ...resRest
          } = res;
          const ranges = valueRanges
            ? transformValueRanges(valueRanges.valueRange)
            : null;

          return {
            ...tag,
            ...resRest,
            ranges,
            status: mapStatus(userHealthRiskDetail.riskStatus),
            value: userValue,
            rangeValue: questionValue,
            remark: userHealthRiskDetail.remark,
            feedback: userHealthRiskDetail.feedback,
            unit: userUnit || questionUnit,
          };
        })
        .filter(item => item);

      return biomarkers.length > 0
        ? {
            ...rest,
            biomarkers,
          }
        : null;
    })
    .filter(item => item);

  return { markerGroups, heightResult, weightResult };
};

const transformPrintResponse = response => {
  const { basicScreeningQuestionResults, ...rest } = response;
  const results = basicScreeningQuestionResults.basicScreeningQuestionResult;
  const { markerGroups, heightResult, weightResult } = groupMarkers(results);
  const riskFactors = results
    .map(item => {
      const { userHealthRiskDetail: risk } = item;
      return risk && risk.riskStatus
        ? {
            status: risk.riskStatus,
            info: risk.remark,
            details: risk.feedback,
          }
        : null;
    })
    .filter(item => item);

  return {
    heightResult,
    weightResult,
    markerGroups,
    riskFactors,
    ...rest,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case basicScreeningResultsLoadBegin:
      return { ...state, fetching: true };
    case basicScreeningResultsLoadFailed:
      return { ...state, fetching: false, error: action.payload };
    case basicScreeningResultsLoadSuccess:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: transformScreeningResultsPayload(action.payload),
      };
    case basicScreeningResultsPrintLoadBegin:
      return { ...state, fetching: true };
    case basicScreeningResultsPrintLoadFailed:
      return { ...state, fetching: false, error: action.payload };
    case basicScreeningResultsPrintLoadSuccess:
      return {
        ...state,
        fetching: false,
        fetched: true,
        printResponse: transformPrintResponse(action.payload),
      };

    default:
      return state; // return previous state
  }
};



// WEBPACK FOOTER //
// ./reducers/basicScreeningResultsReducer.jsx